export default __webpack_public_path__ + "static/media/lo0p.075fee2b.svg";